module.exports = __webpack_public_path__ + "img/dinersclub.bf06bc24.png";